import { useMemo } from 'react';
import { ConversationItem } from '@/models/Conversation';
import dayjs from '@/i18n/dayjs-config';

const getGroupingKey = (date: string | Date): string => {
  const dateObj = dayjs(date);
  const now = dayjs();

  if (now.diff(dateObj, 'hour') < 24) {
    return dateObj.format('YYYY-MM-DD-HH'); // Group by hour
  }

  return dateObj.format('YYYY-MM-DD'); // Group by day
};

export const useTimestampVisibility = (items: ConversationItem[]) => {
  return useMemo(() => {
    if (!items || items.length === 0) {
      return {};
    }

    const visibilityMap: Record<number, boolean> = {};

    for (let i = 0; i < items.length; i++) {
      const currentItem = items[i];
      const previousInTimeItem = items[i - 1];

      if (!previousInTimeItem) {
        visibilityMap[currentItem.Id] = true; // Always show for the oldest item
      } else {
        const currentKey = getGroupingKey(currentItem.DateCreated);
        const prevKey = getGroupingKey(previousInTimeItem.DateCreated);
        visibilityMap[currentItem.Id] = currentKey !== prevKey;
      }
    }

    return visibilityMap;
  }, [items]);
};